<template>
  <div v-if="invitation">
    <v-card color="grey lighten-4" flat>
      <v-card-text>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-chip small :color="statusColor">
            {{ invitationStatusDescription }}
            <v-icon class="ml-1" v-if="invitation.status == 'COMPLETED'">
              mdi-check-all
            </v-icon>
          </v-chip>
        </div>

        <AuthorDetails class="my-3" :author="invitation.reviewer" />

        <section class="mt-2" v-if="invitation.note">
          <strong>Invitation note</strong>
          <div class="abstract">
            {{ invitation.note }}
          </div>
        </section>

        <section class="my-5" v-if="suggestion">
          <h3 class="text-center my-3">Suggested reviewer</h3>

          <AuthorDetails :author="suggestion" />
        </section>

        <div class="d-flex my-5" v-if="canCancelAndRemind">
          <v-btn
            class="white--text mr-2"
            color="red darken-1"
            :disabled="cancelling"
            :loading="cancelling"
            @click="cancelInvitation"
          >
            Cancel Invitation
          </v-btn>

          <v-btn
            text
            class="white--text"
            color="orange darken-1"
            :loading="reminding"
            @click="sendInvitationReminder"
            :disabled="reminding || invitation.reminders > maximumReminders"
          >
            Send Reminder
            <span v-if="invitation.reminders">
              ({{ invitation.reminders }}/{{ maximumReminders }})
            </span>
          </v-btn>
        </div>

        <div class="d-flex" style="line-height: 1.2">
          <small> Invited: {{ formatDate(invitation.createdAt) }}</small>
          <v-spacer></v-spacer>
          <small v-if="invitation.dateResponded">
            Responded: {{ formatDate(invitation.dateResponded) }}
          </small>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { formatDate } from "../../../tools/format";
import {
  statusColor,
  statusDescription,
  canCancelAndRemind,
} from "../../../helpers/invitation";
import AuthorDetails from "../../Author/Includes/AuthorDetails";

export default {
  props: ["invitation"],

  data: () => ({
    reminding: false,
    cancelling: false,
    maximumReminders: 3,
  }),

  components: { AuthorDetails },

  computed: {
    suggestion() {
      return this.invitation.suggestion
        ? JSON.parse(this.invitation.suggestion)
        : null;
    },
    canCancelAndRemind() {
      return canCancelAndRemind(this.invitation.status);
    },
    statusColor() {
      return statusColor(this.invitation.status);
    },
    invitationStatusDescription() {
      return statusDescription(this.invitation.status);
    },
  },

  methods: {
    formatDate,

    sendInvitationReminder() {
      this.reminding = true;

      this.$axios
        .post(`/editorial/invitation/reminder/${this.invitation._id}`)
        .then(() => {
          this.$bus.$emit("snackbar", {
            type: "warning",
            message: "Invitation reminder sent",
          });

          this.$bus.$emit("review.invitation.reminder");
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not send invitation reminder",
          });
        })
        .finally(() => {
          this.reminding = false;
        });
    },

    cancelInvitation() {
      this.cancelling = true;

      const data = { _id: this.invitation._id, status: "CANCELLED" };

      this.$axios
        .put("/editorial/invitation", data)
        .then(() => {
          this.$bus.$emit("snackbar", {
            type: "warning",
            message: "Invitation cancelled",
          });

          this.$emit("cancelled");
          this.$bus.$emit("review.invitation.cancelled");
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not cancel invitation",
          });
        })
        .finally(() => {
          this.cancelling = false;
        });
    },
  },
};
</script>

<style>
</style>